exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".ebx-message{display:inline-block}.ebx-message span{font-weight:700}", ""]);
